var jquery = require("jquery");
window.$ = window.jQuery = jquery;

require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;

require("@fancyapps/fancybox");
import Swiper from 'swiper/bundle';
import ScrollOut from "scroll-out";

var SmoothScroll = require('smooth-scroll');
var scroll = new SmoothScroll('body a[href*="#"]', {
	updateURL: false,
	easing: 'easeInOutSine',
	speed: 150
});

ScrollOut({
	targets: [
		"[data-scroll]",
		".fade-in",
	],
	threshhold: 0.5,
	offset: 0,
	cssProps: { 
	   visibleY: true,
	   viewportY: true,
	},
	onShown(el) {
		el.classList.add("is-shown");
	}
})

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
	// We execute the same script as before
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
});

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.headerContainer').outerHeight();

// READY

$(function () {

	console.log('Website proudly by Imagic Creative');

	homeVideo();

	$("[data-required]").each(function (index) {
		$(this).attr('required', true);
	});

	$('.megaSubmenuDropdown').removeClass('hidden');

	var scroll = $(window).scrollTop();

	if (scroll > navbarHeight) {
		$('header').addClass('nav-down');
	}

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	if ($('.megaSubmenuDropdown li.active').length) {
		$('.megaSubmenuDropdown li.active').each(function() {
			$(this).closest('.parent-li').addClass('active');
		});
	}

	if ($('video[data-desktop-video]').length) {
		$('video[data-desktop-video]').each(function() {
			if ($(this).hasClass('is-shown')) {
				videoSrc($(this));
			}
		});
	}

	var accordions = $('.accordion-container').add('.accordion-small').add('.accordion-vertical');
	if (accordions.length) {
		accordions.each(function() {
			$(this).find('button.accordion').first().trigger('click');
		});
	}
	
	var activeSubmenu = $('header .submenu .active');
	if (activeSubmenu.length) {
		activeSubmenu.each(function() {
			$(this).closest('.submenu').parent().find('a').first().addClass('active');
		});
	}

});


// SCROLL

$(window).on('scroll', function(e) {

	didScroll = true;

	if ($('video[data-desktop-video]').length) {
		$('video[data-desktop-video]').each(function() {
			if ($(this).hasClass('is-shown')) {
				videoSrc($(this));
			}
		});
	}

});



// RESIZE

$(window).on('resize', function() {
	if ($('.accordion-vertical').length && $(window).width() >= 1024) {
		$('.accordion-vertical button.accordion').first().trigger('click');
	}
	homeVideo();
});


$('button.accordion').on("click", function(e) {
	var accordion = $(this).parent().parent();
	accordion.find('.accordion-content').removeAttr('style');
	accordion.find('.accordion-row').removeClass('is-open');
	accordion.find('button.accordion').removeClass('is-open');
	$(this).addClass('is-open');
	$(this).parent().addClass('is-open');
	var content = $(this).parent().find('.accordion-content');
	if (accordion.hasClass('accordion-vertical') && $(window).width() >= 1024) {
		var btns = accordion.find('button.accordion');
		var btnsWidth = btns.outerWidth();
		btnsWidth = btnsWidth * btns.length;
		var width = $(window).width() - btnsWidth;
		content.css('width', width);
		content.find('picture').css('width', width);
		content.find('.overlay').css('width', width);
		if ($(window).width() < 1280) {
			content.find('.block').css('width', width-60);
		}
	} else {
		var height = 0;
		var children = content.children();
		children.each(function() {
			height = height + $(this).outerHeight();
		});
		content.css('max-height', height);
	}
});


$('div[data-target-submenu]').on("click", function(e) {
    $('.toplevel').css('transform','translateX(-100%)');
    $('.submenu').css('transform','translateX(-100%)');
    var targetsubmenu = $(this).data('target-submenu');
    $('[data-submenu]').hide();
    $('[data-submenu="' + targetsubmenu + '"]').show();
});

$('.back').on("click", function(e) {
    $('.toplevel').css('transform','translateX(0%)');
    $('.submenu').css('transform','translateX(0%)');
});

$('.asideMenuTrigger').on("click", function(e) {
	showAside($(this), $(this).attr('data-trigger'));
	e.stopPropagation();
    e.preventDefault();
});

$('main').add('footer').on("click", function(e) {
	if ($('aside.mobileMenu.menuOpened').length) {
		showAside($('.asideMenuTrigger'), $('.asideMenuTrigger').attr('data-trigger'));
	}
});

function showAside(trigger, asideElement) {
	trigger.toggleClass('closed');
	trigger.toggleClass('opened');
	$('body').toggleClass('menuOpened');
	$('aside.mobile'+asideElement).toggleClass('menuOpened');
    var substractHeights = $('.headerContainer').outerHeight();
    var menuContainerHeight = "calc(100vh - " + substractHeights + "px)";
    $('.megaMenuContainer').css("height", menuContainerHeight);
	trigger.find('.hamburger').toggleClass('is-active');

	var activeLink = $('aside .megaSubmenuDropdown .active');
	if (activeLink.length) {
		var menu = activeLink.closest('.megaSubmenuDropdown').data('submenu');
		var menuHeading = $('[data-target-submenu="' + menu + '"]');
		menuHeading.trigger('click');
	}
}

function hasScrolled() {
	if ($('aside.mobileMenu.menuOpened').length || $('.filtersPopupClone.cloned.open').length) {
		return;
	}
		
    var st = $(window).scrollTop();
    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.

    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        if ($('header').hasClass('nav-down')) {
            $('header').removeClass('nav-down').addClass('nav-up');
        }
    } else {
        // Scroll Up
        if(st > navbarHeight && (st + $(window).height() < $(document).height())) {
            $('header').removeClass('nav-up').addClass('nav-down');
        } 
        
        if(st < 5) {
            $('header').removeClass('nav-up').removeClass('nav-down');
        }
    }
    
    lastScrollTop = st;
} 

function videoSrc(video) {
	var videoSrc = video.data('desktop-video');
	var sourceTag = $('<source type="video/mp4"></source>');
	if (video.find('source').length == 0) {
		sourceTag.attr('src', videoSrc);
		sourceTag.appendTo(video);
	}
}


// NEWS FILTERS
$(document).on('click', '#load-more-btn', function(e) {
	$(this).find('.loader').removeClass('hidden').addClass('block');
});
$(document).on('click', '#search-btn', function(e) {
	$(this).find('.loader').removeClass('hidden').addClass('block');
});
$(document).on('click', '.clear-search', function(e) {
	$(this).parent().find('input').val('');
});



// SLIDERS


if ($('.swiper').length) {
	$('.swiper').each(function() {
		const slider = new Swiper($(this)[0], {
			slidesPerView: 1,
			spaceBetween: 0,
			autoResize: false,
			centeredSlides: true,
			speed: 1000,
			navigation: {
				nextEl: $(this).find('.swiper-button-next')[0],
				prevEl: $(this).find('.swiper-button-prev')[0],
			},
			scrollbar: false,
			pagination: false,
			loop: true,
		});
	});
}



// PROJECTS FILTERS
$(document).on('click', '[data-close-popup]', function(e) {
	$('.projectsPanel').removeClass('open');
	$('.projectsFilterClose').removeClass('open');
	$('body').removeClass('overflow-y-hidden');
});
$(document).on('click', '.filterTrigger', function(e) {
	var panel = $(this).data('panel-trigger');
	$('.projectsPanel[data-panel=' + panel + ']').addClass('open');
	$('.projectsFilterClose').addClass('open');
	$('body').addClass('overflow-y-hidden');
});
$(document).on('click', '#load-more-btn', function(e) {
	$(this).find('.loader').removeClass('hidden').addClass('block');
});



// DYNAMIC CSRF IN FORMS
$(function () {
    var formContact = $('#project');
	if (formContact.length) {
		$.ajax({
			url: '/dynamic?form=tellUsAboutYourProject',
			type: 'get',
			dataType: 'json',
			success: function (response) {
				formContact.find('input[name=formHash]').val(response.hash);
				var csrf = response.csrf;
				formContact.find('input[name=' + csrf.name + ']').val(csrf.value);
				console.log(csrf);
			},
		});
	}
});



// HOME VIDEO
function homeVideo() {
	var winRatio = $(window).height() / $(window).width();
	if ($('.home-hero').length && winRatio >= 0.71) {
		$('.video-container').removeClass('full-height');
		var newH = $('.video-container').offset().top + $('.video-container').outerHeight() + $('.home-hero-heading').outerHeight() - ($('.home-hero-heading .h1').outerHeight() / 2) - 2;
		$('.home-hero').height(newH);
		console.log(newH);
	} else if ($('.home-hero').length && winRatio < 0.71) {
		$('.home-hero').attr('style','');
		$('.video-container').addClass('full-height');
	}
	console.log($(window).height() / $(window).width());
}